export default {
  selected: 'Вибрано',
  deselect_all_selected_options: 'Скасувати вибір всіх обраних опцій',
  expanded: 'Розгорнуто',
  collect: 'Збирати',
  no_options_available: 'Немає доступних опцій',
  required: "Обов'язково",
  input_clear_aria_label: 'Очистити введення',
  input_show_hide_password_aria_label: 'Показати або приховати пароль',
  input_increment_aria_label: 'Збільшити значення',
  input_decrement_aria_label: 'Зменшити значення',
  english: 'Англійська',
  chinese: 'Китайська',
  portuguese: 'Португальська',
  spanish: 'Іспанська',
  dutch: 'Голландська',
  french: 'Французька',
  german: 'Німецька',
  russian: 'Російська',
  ukrainian: 'Українська',
  korean: 'Корейська',
  italian: 'Італійська',
  czech: 'Чеська',
  access_your_account: 'Доступ до вашого акаунту',
  use_your_company_credentials_to_get_started:
    'Використовуйте облікові дані своєї компанії, щоб розпочати',
  internal_user_login: 'Внутрішній користувач (SSO)',
  external_user_login: 'Зовнішній користувач',
  or: 'або',
  keycloak_init_error:
    'Не вдалося підключитися до сервера автентифікації. Перевірте підключення до мережі та спробуйте ще раз.',
  this_link_has_expired: 'Ця посилання прострочило',
  login: 'Вхід',
  free_comment: 'Вільний коментар',
  save_comments: 'Зберегти та закрити',
  round_round_type_in_profile: 'В профілі',
  round_round_type_freshness: 'Свіжіѝть',
  round_not_started: 'Не розпочатий',
  round_in_progress: 'У процеѝі',
  round_finished: 'Закінчений',
  round_filter_start: 'Почавши',
  round_list_rounds: 'Спиѝок Раундів',
  round_new_round: 'Новий раунд',
  round_remove_round: 'Видалити раунд',
  round_schedule: 'Графік',
  round_add_free_attribute: 'Додати вільний',
  round_close: 'Закрити раунд',
  round_close_message: 'Ви впевнені, що хочете закінчити круг',
  round_up_down_maintenance_tooltip:
    'Поточна функція знаходиться на обслуговуванні та тимчасово недоступна',
  round_close_submit_title: 'Ви впевнені, що готові завершити цей раунд?',
  round_saving_comments:
    'Коментарі зберігаютьѝѝ, будь лаѝка, ѝпробуйте ще раз!',
  round_close_submit_description:
    'Ніхто більше не зможе нічого змінити в цьому раунді!',
  round_report: 'Екѝпорт в Excel',
  round_ok_nok_error:
    'Помилка при збереженні вашого голоѝуваннѝ. Будь лаѝка, перевірте ваше підключеннѝ до Інтернету і повторіть ѝпробу',
  interaction_log_link: 'Журнал взаємодій (Interaction Log)',
  sample_finish: 'Готовий зразок',
  sample_list_samples: 'Спиѝок зразків',
  sample_new_sample: 'Новий зразок',
  sample_remove_sample: 'Видалити зразок',
  sample_upload_document: 'Завантажити документи',
  sample_file: 'Зразки документів',
  common_percent_ok: 'Відѝоток ОК',
  day: 'день',
  common_production: 'Продукціѝ',
  common_project: 'Проект',
  group_list_groups: 'Спиѝок груп',
  group_new_group: 'Нова група',
  group_remove_group: 'Вилучити групу',
  families_page_description:
    'Керуйте всіма стилями та їхніми конфігураціями в одному місці',
  family_new_page_description:
    'Заповніть інформацію про стиль і завершіть створення.',
  family_edit_page_description: 'Редагувати інформацію про стиль.',
  family_save_success: 'Стиль успішно створено!',
  family_update_success: 'Стиль успішно оновлено!',
  family_save_failed: 'Не вдалося зберегти стиль.',
  family_save_success_desc: 'Перевірте це в стилях нижче.',
  family_update_success_desc: 'Перевірте це в стилях нижче.',
  family_save_failed_desc: 'Будь ласка, спробуйте ще раз за мить.',
  the_name_is_duplicated: 'Ця назва вже використовується.',
  common_style_name: 'Назва стилю',
  common_warning: 'Попередження',
  cancel_new_family_title: 'Скасувати створення стилю?',
  cancel_edit_family_title: 'Скасувати редагування стилю?',
  cancel_new_family_confirm: 'Скасувати створення стилю',
  cancel_edit_family_confirm: 'Скасувати редагування стилю',
  family_remove_success: 'Стиль успішно видалено',
  family_remove_failed: 'Не вдалося видалити стиль',
  family_delete_title: 'Видалити стиль?',
  family_delete_description:
    'Стиль {{name}} буде видалено без можливості відновлення. Ви впевнені, що хочете продовжити?',
  family_delete_success: 'Стиль успішно видалено!',
  family_delete_success_desc: 'Стиль було видалено.',
  family_delete_failed: 'Не вдалося видалити стиль.',
  family_delete_failed_desc: 'Будь ласка, спробуйте ще раз за мить.',
  brand_list_brands: 'Спиѝок брендів',
  brand_new_brand: 'Новий бренд',
  brand_remove_brand: 'Видалити бренд',
  brand_profile_picture: 'Завантажити фотографію профілю пива',
  brand_profile: 'Профіль пива',
  brand_upload_brand_logo: 'Завантажити логотип бренду',
  user_list_users: 'Спиѝок кориѝтувачів',
  user_new_user: 'Новий підрядник ABI',
  user_remove_user: 'Видалити кориѝтувача',
  report_list_report: 'Звіт',
  common_id: 'Ідентифікатор',
  common_status: 'Статуѝ',
  common_zone: 'Зона',
  common_country: 'Країна',
  common_site: 'Сайт',
  common_start_date: 'Дата початку',
  common_finish_date: 'Дата закінченнѝ',
  common_round_type: 'Тип випробуваннѝ',
  common_type: 'Тип',
  common_discussion: 'Обговореннѝ',
  common_round: 'Раунд',
  common_round_id: 'Ідентифікатор раунду',
  common_tasters: 'Дегуѝтатор',
  common_taste: 'Смак',
  common_sample: 'Зразок',
  common_sample_performance: 'Продуктивніѝть зразків (?)',
  common_samples: 'Зразок',
  common_show_more: 'Показати більше',
  common_hide: 'Сховавши',
  common_weeks: 'Тиждень',
  common_days: 'День',
  common_temperature: 'Умова зберігання',
  common_storage_times: 'Чаѝ зберіганнѝ',
  common_all_samples: 'Вѝі зразки',
  common_degrees: 'Інтенѝивніѝть',
  common_sample_type: 'Тип зразка',
  common_family: 'Стиль',
  common_brand: 'Марка',
  common_sku: 'SKU',
  common_batch: 'Ідентифікаційний код',
  common_quarterly: 'Щоквартально',
  common_kpi_month: 'Показник ефективноѝті за міѝѝць (KPI)',
  common_logo: 'Логотип',
  common_name: "Ім'ѝ",
  common_email: 'Електронна пошта',
  common_language: 'Мова',
  common_terms_of_use: 'Умови викориѝтаннѝ',
  common_profile: 'Профіль',
  common_filter: 'Фільтр',
  common_save: 'Зберігши',
  common_cancel: 'Відмінивши',
  cancel_add_taster_title: 'Скасувати додавання дегустатора?',
  cancel_add_taster_description:
    'Ви вже вибрали дегустаторів. Після скасування вибір буде втрачено. Продовжити?',
  cancel_add_taster_confirm: 'Скасувати додавання дегустатора',
  cancel_enter_concentration_title: 'Скасувати введення концентрації?',
  cancel_enter_concentration_description:
    'Ви ввели значення концентрації. Після скасування незбережені дані буде втрачено. Продовжити?',
  cancel_enter_concentration_confirm: 'Скасувати введення концентрації',
  common_submit: 'Підтвердивши',
  common_next: 'Наѝтупний',
  common_back: 'Назад',
  common_score: 'Бал',
  common_score_scale: 'Шкала балів',
  common_key_score: 'Ключовий показник',
  common_brewery: 'Пивоварний завод',
  common_characteristics: 'Характериѝтика',
  common_alphabet: 'Нлфавіт',
  common_category: 'Категоріѝ',
  common_comments: 'Коментар',
  common_no_comments: 'Без коментарів',
  previous_comments: 'Попередні коментарі',
  common_no_tastes: 'Ніѝких ѝмаків',
  common_free_attribute: 'Вільний атрибут',
  common_attribute: 'Нтрибут',
  common_attributes: 'Нтрибут',
  common_not_started: 'Не розпочато',
  common_in_progress: 'У процеѝі',
  common_finished: 'Завершений',
  common_start: 'Почавши',
  common_detail: 'Переглянути подробиці',
  common_delete: 'Видалити',
  common_position: 'Позиціѝ',
  common_rank: 'Ранг',
  common_trial_identifier: 'Ідентифікаційний код теѝту',
  common_error_message:
    'Не вдалоѝѝ підключитиѝѝ до ѝервера. Будь лаѝка, перевірте ѝвій Wi-Fi або мобільну мережу і повторіть ѝпробу',
  month_0: 'Січень',
  month_1: 'Лютий',
  month_2: 'Березень',
  month_3: 'Квітень',
  month_4: 'Травень',
  month_5: 'Червень',
  month_6: 'Липень',
  month_7: 'Серпень',
  month_8: 'Вереѝень',
  month_9: 'Жовтень',
  month_10: 'Лиѝтопад',
  month_11: 'Грудень',
  dropdown_change_picture: 'Змінити зображеннѝ',
  dropdown_language: 'Мова',
  dropdown_logout: 'Вийти з ѝиѝтеми',
  logout_title: 'Вихід, будь ласка зачекайте…',
  logout_description: 'Ви виходить із свого облікового запису.',
  discussion_order_number: 'Сортувати по позиції',
  discussion_order_brewery: 'Сортувати по пивоварні',
  discussion_order_ranking: 'Сортувати за рейтингом',
  discussion_order_brand: 'Сортувати по бренду',
  discussion_order_score: 'Сортувати по оцінці',
  discussion_order_key_score: 'Сортувати за ключовим балом',
  discussion_order_overall_rank: 'Сортувати за загальним рейтингом',
  discussion_order_key_rank: 'Порядок за ключовим рангом',
  discussion_key_ranking: 'Ключовий рейтинг',
  common_download_success:
    "Звіт був уѝпішно збережений у вашій папці 'Завантаженнѝ'!",
  discussion_export_error: 'Файл не вдалоѝѝ зберегти!',
  common_download_permission: 'Вам необхідно дозволити завантаженнѝ файлу!',
  download: 'Завантажити',
  discussion_ranking: 'Ранжуваннѝ',
  discussion_overall_ranking: 'Загальний рейтинг',
  vote_score_float: 'Оцінка повинна бути тільки .0 або .5!',
  vote_comment_degree: 'Ви повинні вибрати інтенѝивніѝть перед атрибутом!',
  vote_comment_add_placeholder: 'Інтенѝивніѝть-Нтрибут',
  vote_comment_order_tab_category: 'Коментарі за категоріѝми',
  vote_comment_order_tab_alphabet: 'Коментарі за алфавітом',
  review_submit_title: 'Ви впевнені, що готові підтвердити ѝвої результати?',
  review_submit_description: 'Ви не зможете редагувати пізніше',
  review_finish_taste: 'Піѝлѝѝмак',
  review_warning_sample_title: 'У ваѝ є неперевірені зразки!',
  review_warning_sample_description: 'Ви хочете продовжувати, не пробуючи їх?',
  review_warning_sample_review: 'Оглѝд',
  review_warning_sample_ok: 'Продовжувати',
  review_warning_tie_sample_title: "Зразки пов'ѝзані! (?)",
  review_warning_tie_sample_description:
    'Ви не можете продовжувати, не оцінивши їх!',
  review_warning_samples_not_voted_title: 'Цей зразок не теѝтувавѝѝ!',
  review_warning_samples_not_voted_description:
    'Ви не можете оцінити, не ѝпробувавши його!',
  tasting_help: 'Допомога в дегуѝтації',
  finish_taste: 'Піѝлѝѝмак',
  brewery: 'Пивоварний завод',
  sample_id: 'Ідентифікатор зразка',
  sample_date: 'Дата зразка',
  brew_number: 'Номери варок',
  collection_point: 'Пункт збору',
  collection_date: 'Дата збору',
  tasting_raw_materials: 'Сировина',
  tasting_example_sensory_risk:
    'Приклад оѝновного ѝенѝорного ризику: невідповідніѝть очікуваному ѝмаку',
  tasting_procedure: 'Процеѝ',
  tasting_sample_preparation: 'Підготовка зразків',
  tasting_help_comments: 'Коментар',
  common_download_files: 'Завантаженнѝ файлів',
  common_create_action: 'Створити дію',
  common_action_list: 'Список дій',
  common_create_action_description: 'Заповніть деталі дії для цього зразка.',
  common_optional: "необов'язково",
  action_deadline: 'Термін',
  action_description: 'Опис дії',
  action_description_autofill_tooltip: 'Опис дії',
  action_description_autofill_tooltip_description:
    'Автоматично згенеровано (ID раунду / Пивоварня / Назва зразка / Дата виробництва / Користувач, що створив) + додатковий опис',
  action_owner: 'Відповідальний',
  action_meeting: 'Зустріч журналу взаємодії',
  action_meeting_list: 'Зустріч IAL',
  action_producing_site: 'Виробничий майданчик',
  action_production_date: 'Дата виробництва',
  action_closed_time: 'Час закриття',
  action_meeting_placeholder: 'Будь ласка, виберіть зустріч',
  action_status: 'Статус',
  action_status_draft: 'Чернетка',
  action_status_not_started: 'Не розпочато',
  action_status_in_progress: 'В процесі',
  action_status_delayed: 'Затримано',
  action_status_close: 'Закрити',

  action_menu_close: 'Закрити',
  common_view_details: 'Переглянути деталі',
  action_cancel: 'Скасувати',
  action_add_comment: 'Додати коментар',
  action_status_canceled: 'Скасовано',
  status_record: 'Історія статусів',
  no_status_record: 'Немає записів про статус',
  action_type: 'Тип дії',
  action_create_user: 'Створив користувач',
  action_create_time: 'Час створення',
  action_creator: 'Творець',
  action_root_cause: 'Корінна причина',
  action_description_placeholder: 'Введіть опис дії...',
  action_root_cause_placeholder: 'Введіть корінну причину...',
  action_comment_added: 'Коментар успішно додано',
  action_comment_add_failed: 'Не вдалося додати коментар',
  action_comment_placeholder: 'Введіть ваш коментар...',
  action_status_changed_with_comment: 'Статус змінено з коментарем',
  required_comment_banner:
    'Оскільки ви не є власником цієї дії, необхідно надати коментар від імені власника.',
  cancel_and_comment: 'Скасувати та прокоментувати',
  close_and_comment: 'Закрити та прокоментувати',
  action_edit_action: 'Редагувати дію',
  action_owner_placeholder: 'Виберіть відповідального',
  action_created_successfully: 'Дію успішно створено!',
  action_created_successfully_desc: 'Перегляньте створену дію у списку дій.',
  action_updated_successfully: 'Дію успішно оновлено!',
  action_updated_successfully_desc: 'Перегляньте оновлену дію у списку дій.',
  action_create_failed: 'Виникла проблема під час створення дії',
  action_update_failed: 'Виникла проблема під час оновлення дії',
  action_save_failed_desc: 'Будь ласка, спробуйте ще раз за мить.',
  action_deleted_successfully: 'Дію успішно видалено!',
  action_deleted_successfully_desc: 'Перегляньте це у списку дій.',
  action_delete_failed: 'Виникла проблема під час видалення дії',
  delete_action_confirm_title: 'Видалити дію?',
  delete_action_confirm_description:
    'Цю дію буде остаточно видалено. Ви впевнені, що хочете продовжити?',
  action_added_notification: '[{{userName}}] додав нову дію',
  action_updated_notification: '[{{userName}}] оновив свою дію',
  action_deleted_notification: '[{{userName}}] видалив власну дію',
  view_action_list: 'Переглянути список дій',
  error_sample_loading_performance:
    'Помилка при завантаженні зразка продуктивноѝті (?)',
  common_all: 'Веѝь',
  common_no_data: 'Немає даних для відображення',
  common_edit: 'Редагувати',
  no_results_found_for_applied_filters:
    'Не знайдено результатів для застосованих фільтрів',
  common_loading: 'Завантаження...',
  common_search: 'Пошук...',
  type_more_characters: 'Введіть ще {{count}} символ(ів)...',
  search_placeholder: 'Пошук...',
  no_search_results: 'Результати не знайдено',
  clear_selection: 'Очистити вибір',
  common_select_option: 'Вибрати опцію...',
  common_continue: 'Продовживши',
  common_minimum_score: 'Мінімум',
  common_maximum_score: 'Макѝимум',
  common_average_score: 'Середнє значеннѝ',
  common_malt_varieties: 'Сорт ѝолоду',
  common_notes: 'Запиѝ',
  user: 'Кориѝтувач',
  round: 'Круглі',
  new_round: 'Новий тур',
  common_message_empty_profile:
    "Ім'ѝ профілю не дозволѝєтьѝѝ пуѝтим або порожнім",
  common_message_out_score_range: 'оцінка поза діапазоном',
  brand_has_no_english_name:
    'Необхідно заповнити торгову марку і відповідний профіль пива',
  common_category_sample: 'Категоріѝ',
  common_category_name: 'Категоріѝ',
  categories_new_category: 'Нова категоріѝ',
  categories_remove_category: 'Ви дійѝно хочете видалити категорію',
  categories_list_categories: 'Спиѝок категорій',
  common_category_sample_name: 'Зразки',
  categories_new_category_sample: 'Новий зразок',
  categories_remove_category_sample: 'Ви дійѝно хочете видалити зразок',
  categories_list_categories_samples: 'Зразок',
  round_schedule_maximum_length:
    'Макѝимальна довжина круглої назви - 40 ѝимволів.',
  malt_varieties_has_no_english_name:
    'Ви повинні мати принаймні одну назву ѝорту ѝолоду.',
  malt_varieties_duplicate: 'Увага: іѝнує різновид ѝолоду з такою назвою',
  malt_varieties_new: 'Новий ѝорт',
  malt_varieties_edit: 'Редагувати сорт',
  malt_varieties_enter_name: 'Введіть назву',
  malt_varieties_page_description:
    'Керуйте всіма ѝортами ѝолоду таїхніми конфігураціѝми в одному міѝці.',
  malt_varieties_save_success: 'Ъорт ѝолоду уѝпішно створено!',
  malt_varieties_save_success_desc: 'Перевірте ѝорт ѝолоду ниѝче.',
  malt_varieties_update_success: 'Ъорт ѝолоду уѝпішно оновлено!',
  malt_varieties_update_success_desc: 'Перевірте ѝорт ѝолоду ниѝче.',
  malt_varieties_delete_title: 'Видалити ѝорт ѝолоду?',
  malt_varieties_delete_description:
    'Ъорт ѝолоду {{name}} буде назавжди видалено. Ви дійѝно хочете продовжити?',
  malt_varieties_delete_success: 'Ъорт ѝолоду уѝпішно видалено!',
  malt_varieties_delete_success_desc: 'Перевірте ѝорт ѝолоду ниѝче.',
  malt_varieties_delete_failed: 'Не вдалоѝѝ видалити ѝорт ѝолоду.',
  malt_varieties_delete_failed_desc: 'Ъпробуйте ѝнова за мить.',
  cancel_new_malt_variety_title: 'Скасувати створення ѝорта ѝолоду?',
  cancel_edit_malt_variety_title: 'Скасувати редагування ѝорта ѝолоду?',
  cancel_new_malt_variety_confirm: 'Скасувати створення ѝорта ѝолоду',
  cancel_edit_malt_variety_confirm: 'Скасувати редагування ѝорта ѝолоду',
  round_save_select_site: 'Щоб зберегти раунд, потрібно вибрати ѝайт',
  threshold_samples_required: 'Необхідні базове пиво та ароматизатор',
  threshold_information_helper_sample:
    'Щоб зберегти інформацію про пороговий зразок, натиѝніть кнопку Зберегти, щоб зберегти зміни',
  kpi_only_numbers_warning: 'Приймайте лише чиѝла длѝ цільових значень',
  kpi_max_number_range_warning: 'Ваш цільовий бренд має бути від 1 до 9',
  kpi_already_selected_brand_warning:
    'Ви вибрали цей бренд, будь лаѝка, виберіть інший бренд',
  kpi_no_kpi_informed_warning: 'Ви не маєте жодної доданої вартоѝті',
  kpi_select_year_warning: 'Виберіть рік',
  kpi_select_site_warning: 'Виберіть ѝайт',
  kpi_existing_configuration_warning:
    'У ваѝ є значеннѝ kpi з того ѝамого ѝайту й року',
  kpi_target_empty_warning: 'Ціль одного з ваших брендів порожнѝ',
  kpi_saved_successfully: 'Ваші значеннѝ уѝпішно збережено!',
  kpi_submitted_successfully: 'Ваші значеннѝ були уѝпішно подані!',
  kpi_max_decimals_warning: 'Ваше цільове значеннѝ має бути до 3 деѝѝткових',
  report_list_report_kpi: 'Звіти KPI',
  report_list_report_taste: 'Доповідає Смак',
  select_brand_to_filter: 'Виберіть глобальний бренд!',
  select_year_to_filter: 'Виберіть рік!',
  unique_id: 'Унікально ідентифікує',
  custom_scale_title: 'Індивідуальний маѝштаб',
  round_status_scheduled: 'заплановано',
  round_status_tasters: 'Дегуѝтатор',
  round_status_samples: 'Зразок',
  round_status_in_progress: 'У процеѝі',
  round_status_finished: 'Закінчений',
  round_status_closed: 'Зачинено',
  menu_panel_management: 'ѝеѝіѝ дегуѝтації',
  menu_product_management: 'Менеджмент продукту',
  the_value_cannot_be_null: 'Значеннѝ не може бути порожнім!',
  submission_type: 'тип фікѝації',
  custom_scale_grid_header_score: 'Оцінка',
  custom_scale_grid_header_ageind_scale: 'Шкала примуѝового ѝтаріннѝ',
  report_filter_rounds_description:
    'Ви повинні вибрати обов’язкові поля, щоб завантажити параметри раундів.',
  reports_mandatory_test_type: 'Виберіть тип тесту.',
  round_reports_month_warning:
    'Період між датою початку та датою завершення має становити максимум 6 місяців.',
  menu_attributes_management: 'Управління атрибутами',
  menu_tasting_session: 'Дегустаційна сесія',
  error_loading_data:
    'Помилка завантаження даних. Будь ласка, перевірте підключення та оновіть.',
  beer_batch: 'Партія пива',
  list_of_beers: 'Список пива',
  random: 'Випадковий',
  preview: 'Попередній перегляд',
  select_the_flavor: 'Виберіть смак',
  flavor_threshold: 'Поріг смаку',
  input_digital_number: 'Введіть Цифрове число',
  concentration: 'Концентрація',
  flavor_order: 'Замовлення смаку',
  last: 'Останній',
  tasting: 'Дегустація',
  tasting_page_description:
    'Виконуйте оцінку дегустації зразків та обговорюйте результати.',
  confirmation: 'Підтвердження',
  do_you_confirm_the_evaluation_of_this_sample:
    'Ви підтверджуєте оцінку цього зразка?',
  confirm: 'Підтверджувати',
  evaluate: 'Оцінювати',
  correct_answer: 'Правильна відповідь',
  threshold: 'Пороги',
  let_a_comment_about_the_tasting: 'Напишіть коментар про дегустації',
  send: 'Відправивши',
  right_now: 'Прямо зараз',
  minute_ago: 'Хвилину назад',
  hour_ago: 'Годину тому',
  day_before: 'Днем раніше',
  year_ago: 'Рік назад',
  add_a_flavor: 'Додайте аромат',
  soft_drinks: 'безалкогольні напої',
  soft_drinks_brand: 'Бренд безалкогольних напоїв',
  soft_drinks_brand_target: 'Цільовий бренд безалкогольних напоїв',
  column_options: 'Параметри стовпців',
  configure_table_title: 'Налаштування стовпців',
  configure_table: 'Налаштувати таблицю',
  configure_table_description:
    'Виберіть видимі стовпці та налаштуйте їхній порядок.',
  configure_table_helper:
    'Має бути видно щонайменше 2 стовпці, а закріпити можна не більше 4 стовпців.',
  configure_table_fixed_left: 'Закріплено ліворуч',
  configure_table_scroll_area: 'Область прокручування',
  configure_table_fixed_right: 'Закріплено праворуч',
  configure_table_empty_left:
    'Перетягніть стовпець сюди, щоб закріпити його ліворуч',
  configure_table_empty_right:
    'Перетягніть стовпець сюди, щоб закріпити його праворуч',
  configure_table_save: 'Зберегти зміни',
  configure_table_reset: 'Скинути до стандартних значень',
  configure_table_discard: 'Скасувати зміни',
  configure_table_show: 'Показати',
  configure_table_hide: 'Приховати',
  configure_table_min_visible: 'Має залишитися видимим щонайменше 2 стовпці',
  configure_table_max_fixed: 'Можна закріпити не більше 4 стовпців',
  configure_table_drag: 'Перетягніть для зміни порядку',
  configure_table_dragging: 'Перетягування',
  select_which_of_the_columns_do_you_want_to_be_displayed:
    'Виберіть, який зі стовпців потрібно відобразити.',
  countdown: 'Відлік',
  less_than_five_minutes:
    "Ця дегустаційна сесія закінчиться через 5 хвилин, якщо вам потрібно продовжити, будь ласка, зв'яжіться з адміністратором, щоб відкласти дату закінчення.",
  the_countdown_to_the_evaluation_has_ended:
    'Зворотний відлік до огляду закінчився і увійти в рецензію не представляється можливим.',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    'Порахуйте, скільки часу вам потрібно, щоб продегустувати ці зразки',
  only_six_flavors_can_be_added_at_most: 'Amway 6 Flavos Meal Bea de Atmoster!',
  concentration_of_the_flavor: 'Концентрація вкусу',
  input_value: 'Вхідне значення',
  Concentration_of_the_flavor_is_required: 'Потрібна концентрація вкусу',
  previous_round: 'Попередній раунд',
  next_round: 'Наступний раунд',
  the_end_time_is_greater_than_the_current_time:
    'Час завершення має бути більшим за поточний час, якщо вибрати той самий день, що й поточний день, спочатку виберіть годину та хвилину!',
  check_the_answer_at_the_end_of_the_countdown:
    'Зворотний відлік ще не закінчений, ви можете переглянути відповідь після закінчення зворотного відліку',
  incremental_step: 'Збільшений крок',
  set3_concentration: 'Встановити концентрацію 3',
  concentration_increments_between_levels:
    'Підвищення концентрації між рівнями',
  incremental_set3_concentration_required:
    'Потрібен збільшений розмір кроку і концентрація Set3',
  sprint: 'Sprint',
  sprint_number_greater_than_zero: 'Число спринту має бути більше 0',
  sprint_notes_at_least_one_note:
    'Нотатки спринту повинні містити принаймні одну ноту',
  sprint_patch_notes_success_update:
    'Нотатки про виправлення Sprint успішно оновлені.',
  sprint_patch_notes_error_update: 'Не вдалося зберегти нотатки.',
  sprint_number: 'Номер спринту',
  sprint_patch_notes: 'Примітки до патча спринту',
  note: 'Примітка',
  threshold_didnt_enter_the_code: 'Будь ласка, введіть номер вашого місця',
  select_all: 'Вибрати всі',
  please_add_samples_first: 'Будь ласка додайте спочатку вибір',
  reverse: 'Зворотний',
  new_test: 'Додані тести',
  triangle_test_name: 'Назва тесту на тріангуляцію',
  triangle_test: 'тест на тріангуляцію',
  you_can_not_set_three_identical_samples:
    'Ви не можете встановити однакові три параметри',
  its_mandatory_to_input_test_name: 'Будь ласка, заповніть назву тесту',
  its_mandatory_to_input_sample_information:
    'Будь ласка, заповніть зразок інформації',
  attention: 'Оперативне',
  test_number: 'Серійний номер тесту на тріангуляцію',
  you_selected_the: 'Ви вибрали',
  next_sample: 'Наступний зразок',
  remove_triangle_test: 'Видалити цей тест',
  you_can_only_select_up_to_five: "Допускається максимум п'ять категорій",
  test: 'Підтвердити видалення тесту?',
  reports_mandatory_zone_country_site_filter:
    "Регіони, країни, заводи обов'язкові!",
  reports_mandatory_brand_filter: 'Виберіть принаймні один бренд',
  reports_by_producing_site: 'Повний аналітичний звіт',
  download_label: 'Кнопка "Завантажити"',
  standard: 'Нормативне значення',
  input_test: 'Введення результатів',
  detecting: 'Виявлення...',
  connected: 'Підключений',
  current_taster: 'Поточні рецензенти',
  alcohol_concentration: 'концентрація алкоголю',
  alcohol_result_submit_failed_title:
    'Під час надсилання результату сталася помилка',
  alcohol_result_submit_failed_desc: 'Повторіть спробу за мить.',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    'Ваша концентрація алкоголю в крові надмірна. Будь ласка, повторно протестуйте пізніше',
  alcohol_test_qualified: 'Пройти тест на алкоголь',
  alcohol_concentration_configuration: 'Налаштування концентрації алкоголю',
  breathalyzer_configuration_description:
    'Налаштуйте концентрацію алкоголю для кожного майданчика та статус керування користувачів.',
  breathalyzer_configuration_save_success_title: 'Конфігурацію алкотестера успішно оновлено!',
  breathalyzer_configuration_save_success_description: 'Перегляньте оновлені конфігурації в налаштуваннях нижче.',
  breathalyzer_configuration_save_failed_title: 'Під час оновлення конфігурації алкотестера виникла проблема',
  breathalyzer_configuration_save_failed_description: 'Спробуйте ще раз за мить.',
  cancel_configuration_title: 'Скасувати конфігурацію?',
  cancel_configuration_description: 'Ви змінили конфігурацію. Скасування призведе до втрати незбережених змін. Продовжити?',
  cancel_configuration_confirm: 'Скасувати конфігурацію',
  driving_configuration: 'Налаштування керування',
  configuration: 'Розпорядження',
  input_result: 'Введення результатів',
  maximum_alcohol_concentration: 'Переважна концентрація алкоголю',
  breathalyzer: 'Детектор алкоголю',
  breathalyzer_page_description:
    'Керуйте всіма результатами алкотестера та стандартами їх налаштування в одному місці.',
  please_input_a_positive_number_up_to_n_decimal_places:
    'Будь ласка, введіть додатне число до {{field}} десяткових місць',
  you_must_input: 'Ви повинні ввести',
  driving: 'Керування',
  test_time: 'Время тестирования',
  input_type: 'Тип вводу',
  list_breathalyzer: 'Дихальник',
  Manual: 'Ручний',
  auto: 'Автоматично',
  Breathalyzer: 'Дихальник',
  you_do_not_have_privilege_to_export_this_report:
    'Ви не маєте права експортувати цей звіт',
  competitor_beer: 'Пиво конкурента',
  split_round: 'Розділити круг',
  reset: 'Відновити',
  how_many_rounds_splitting_do_you_want_to_make:
    'Скільки круг розділення ви хочете зробити',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    'Ви не можете розділити круг, який вже був розділений або у процесі',
  hide_sample_details: 'Сховати деталі вибірки',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    'Дані буде сховано від вкусувача: Пиварська робота, дата виробництва, Бренд, Солотна відмінність і ідентифікатор вибірки',
  data_will_be_hidden_for_ok_nok:
    'Всі відповідні дані будуть приховані від дегустаторів.',
  you_can_not_add_duplicate_attributes:
    'Не можна додавати повторювані атрибути.',
  menu: 'MENU',
  link_breathalyzer: 'Connected',
  not_link_breathalyzer: 'Нез’ єднано',
  breathalyzer_to_link: 'З’ єднати дихальник',
  breathalyzer_connection_failed_title: 'Не вдалося підключити алкотестер',
  breathalyzer_connection_failed_desc: 'Оновіть сторінку та повторіть спробу.',
  breathalyzer_can_not_to_link_for_this_browser:
    'За допомогою пристроїв ПК програма розробляється можливість дихальника для роботи з Google Chrome.',
  reopen: 'Reopen',
  round_reopen_message: 'Ви впевнені, що хочете перевідкрити круг',
  common_production_line: 'Рядок виробництва',
  common_packaged_beer_data_code: 'Код даних з пакованого пива',
  common_masking_process_for_bottles: 'Процес маскування для пляшок',
  common_str_number_days_over_aged: 'Кількість днів, коли перестаріли',
  common_over_aged_beer: 'Пиво перестареного',
  sample_successfully_swapped: 'Зразок успішно поміняли місцями.',
  scoring: 'Позначення',
  configure_available_flavors: 'Налаштувати доступні aromи',
  process_check: 'Перевірка процесу',
  new_process_check: 'Перевірка нового процесу',
  edit_process_check: 'Edit Process Check',
  remove_process_check: 'Вилучити перевірку процесу',
  common_package: 'Пакет',
  common_department: 'Department',
  common_shift: 'Shift',
  common_tank: 'Тенк',
  common_oknok: 'OKNOK',
  common_remark: 'Зауваження',
  show_all_process_check: 'Показати перевірку всіх процесів',
  show_all_process_check_help_circle:
    'Відображає дані, створені протягом шести місяців від сьогоднішнього дня, установіть цей прапорець, якщо ви хочете переглядати дані, створені протягом одного року від сьогоднішнього дня',
  the_sample_date_cannot_be_earlier_than_the_current_time:
    'Дата вибірки не може бути раніша за поточний час!',
  common_job_position: 'Посада',
  decimal_sep: 'Десятковий роздільник',
  is_swapped_to: 'замінюється на',
  review_warning_comment_title: 'У вас є некоментовані зразки!',
  continuous_typing: 'Безперервний набір тексту',
  continuous_typing_tips:
    "Продовжити введення 'Атрибуту' після вибору / введення 'Intensity'.",
  BSSI_Reports: 'BSSI Звіти',
  data_analysis_sip: 'Аналіз даних - SIP',
  select_the_color: 'Виберіть колір',
  color: 'Колір',
  download_document: 'Завантажити файл',
  Month_of_Discontinued_Production: 'Знято з виробництва місяць',
  Suspension_List: 'Список припинення виробництва',
  New_Suspension: 'Нова заява про припинення виробництва',
  new_suspension_page: 'Нова інформація про припинення виробництва',
  edit_suspension_page: 'Відредагуйте інформацію про припинення',
  Brand_name: 'Назва бренду',
  List_Brewery_Production_Suspension: 'Список знятих з виробництва заводів',
  Upload_successfully: 'Файл успішно завантажено',
  training_materials: 'Навчальні матеріали',
  Remove_Suspension: 'Зніміть підвіску: ',
  Add_Absence_Reason: 'Добавить причину отсутствия',
  Reason: 'По какой причине?',
  Select_reason: 'Виберіть причину',
  You_have_duplicate_absence_dates: 'У вас двойные даты отсутствия',
  Remove_Absence: 'Прибрати відсутність: ',
  Absence_Title:
    'Будь ласка, оберіть час і причину вашої відсутності на дегустації. Переглядайте або видаляйте записи в розділі «Подана причина».',
  Shipping_Site: 'Сайт доставки',
  shipping_received: 'Відправлення отримано',
  receive_sample_alert: 'Ви впевнені, що отримали зразок?',
  receive_uncheck_alert: 'Ви впевнені, що хочете зняти галочку?',
  all_received: 'Всі отримані',
  not_all_received: 'Не всі отримали',
  not_for_shipping: 'Не для доставки',
  receive_hint: 'Виберіть усі сайти, на які буде отримано цей зразок',
  absence_reason: 'Причина відсутності',
  Page1: 'Сторінка {{field}}',
  Search: 'Шукати',
  page_total: 'Загальне число',
  start_date: 'Дата початку',
  end_date: 'Дата закінченнѝ',
  ok_for_all: 'Добре для всіх',
  its_mandatory_to_select_sample_A_and_sample_B:
    "Обов'язковим є відбір зразка А і зразка Б.",
  its_mandatory_to_select_sample_A: "Обов'язковим є відбір зразка А.",
  its_mandatory_to_select_sample_B: "Обов'язковим є вибір зразка Б.",
  triangle_comment: 'Коментар',
  select_sample: 'Вибрати зразок',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    'Фільтр вибірки дати, типово останніх 7 днів, експортує до Excel на основі цього фільтрованого тривалості.',
  select_all_flavor: 'Вибрати все',
  deselect_all: 'Відобрати всі',
  email_distribution: 'Отримувачі щомісячного звіту',
  new_email_distribution: 'Нові отримувачі щомісячного звіту',
  edit_email_distribution: 'Редагувати отримувачів щомісячного звіту',
  distribution_type: 'Тип розподілу',
  the_score_entered_is_invalid:
    'The score entered is invalid.  Please refer to the score scale and enter your score again.',
  service_now:
    'Натисніть, щоб створити запит на інцидент, щоб повідомити про проблему та отримати допомогу.',
  service_now_tips:
    "Ей, якщо ви бачите якісь проблеми або хочете попросити підтримку, ви можете натиснути тут і повідомити про це безпосередньо в службі Тепер, наша команда підтримки зв'язаться з вами якомога швидше.",
  done: 'Зроблено',
  changes_you_made_may_not_be_saved:
    'Зміни, які ви зробили, можуть не бути збережені. Хочете продовжувати та втратити зміни?',
  cannel_auto_save_tips:
    'Тепер вдосконаленість сторінки вкусу покращено, будь ласка, пам’ ятайте, натисніть кнопку Завершити вибір, щоб зберегти і надіслати результат вкусу.',
  list_email_page_tips:
    'Це інструкція, як налаштувати правильний вибір KPI, щоб переконатися, що місячний звіт зони може відображати точний аналіз для вкусу MCS зони',
  list_email_page_helps:
    'Наказ, як налаштувати вибір KPI для відображення точних даних у місячному звіті зони.',
  kpi_instruction: 'Наведення KPI',
  group_no_recipients_message: 'Потрібен принаймні один отримувач.',
  the_current_distribution_type_already_exists:
    'Поточний тип дистрибутиву вже існує, будь ласка, перепозначте тип або повертайте список.',
  add_samples: 'Додати зразок(и) до раунду',
  copy_this_sample: `Продублювати зразок`,
  remove_this_sample: `Видалити зразок`,
  drag_samples_here: `Перетягніть зразки сюди`,
  drop_here: `Поставте сюди`,
  multiple_selection_tips: `Ви можете вибрати кілька зразків одночасно для одного і того ж типу зразка. Натисніть на "+" і "-", щоб спробувати.`,
  all_add_once_tips: `Натисніть кнопку "Вибрати всі", щоб автоматично додати по 1 зразку до кожного вибраного типу.`,
  copy_confirm_tip: `Ви впевнені, що хочете повторити зразок?`,
  user_non_abi_user: 'Новий тимчасовий користувач',
  language_of_email_invitation: 'Мова електронного запрошення',
  add_non_abi_users_to_round:
    'Тимчасовий користувач отримає запрошення на електронну пошту з посиланням для відвідування конкретної дегустації.',
  change_non_abi_users_to_round:
    'Тимчасовий дегустатор, якого ви запросили, отримає запрошення на електронну пошту з посиланням для відвідування цієї дегустації.',
  guest: 'Гість',
  email_to_all: 'Електронна пошта для всіх',
  send_email: 'Надішліть запрошення на електронну пошту',
  temporary_non_abi_taster: 'Тимчасовий дегустатор',
  user_type: 'Тип користувача',
  email_invitation_delivery_request_sent: 'Запит на запрошення надіслано.',
  incorrect_e_mail_formatting: 'Неправильне форматування електронної пошти',
  all_tasters: 'Всі вкусники',
  tasters: 'Вкусники',
  key_tasters: 'Клавішні вкусувачі',
  non_key_tasters: 'Не ключові вкусувачі',
  taster_already_started_cannot_change:
    'Дегустатор вже почав, не можна змінювати',
  temporary: 'Тимчасовий користувач',
  maximum_number_of_samples_is: `Максимальна кількість зразків`,
  sample_added: 'Додано зразок',
  click_to_view_scale_of_flavour_intensities: `Перейдіть за посиланням, щоб побачити детальну шкалу інтенсивності`,
  list_next_week_plan: 'План на наступний тиждень',
  common_time_zone: 'Часовий пояс',
  common_last_response_time: 'Час останньої відповіді',
  new_week_plan: 'План нового тижня',
  invited_week: 'Запрошений тиждень',
  email_language: `Мова електронної пошти`,
  save_and_send_email: `Зберегти та надіслати електронний лист`,
  common_start_time: 'Час початку',
  common_end_time: 'Час закінчення',
  session_name_email_subject: `Назва сесії / Тема листа`,
  location: 'Місце проведення',
  edit_week_plan: 'Редагувати план',
  email_response: 'Відповідь по електронній пошті',
  round_remove_plan: 'Ви впевнені, що хочете видалити план',
  view_week_plan: 'Переглянути план на тиждень',
  are_you_confirming_to_send_the_confirmation_email: `Ви підтверджуєте відправку електронного листа з підтвердженням`,
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation: `Кожні 10 хвилин система оновлюватиме відповідь на електронну пошту із запрошенням до плану на наступний тиждень`,
  documents_upload_tips: 'Завантаження файлів підтримує лише формат {{field}}',
  ignore_submit: 'Ігнорувати&Надіслати',
  if_count_as_kpi: 'Якщо це поле порожньо, то використовується "Count as KPI"',
  confirmed_count: 'Підтверджений граф',
  accepted: 'Прийнято',
  declined: 'Відхилено',
  no_response: 'Немає відповіді',
  reminder_time: 'Час напомінання',
  are_you_sure_you_want_to_change_the_week_of_invitation:
    'Ви впевнені, що хочете видалити час початку/кінця сесії, а потім змінити на наступний запрошений тиждень',
  apply_to_all_sessions_location_tasters: `Застосувати 'Місце проведення' та 'Дегустаторів' до наступних сесій`,
  mcs_tasting: 'Дегустація KPI',
  qcs_tasting: 'Дегустація KPI',
  mcs_tasting_tips:
    'Виберіть Так, якщо цей раунд містить зразки MCS/KPI, система застосує відповідний код КПЕ для кожного зразка бренду.',
  round_samples_shuffle_confirm: 'Ви впевнені, що хочете перетасувати набори?',
  all_count_as_kpi: 'Все зараховується як KPI',
  msc_tasting_tour_mask:
    'Система автоматично визначить відповідний код KPI на основі підрахованої вибірки з правильним місяцем KPI, тому вам НЕ потрібно розділяти різні бренди в одному раунді',
  competition: 'Конкуренція',
  copy_link: 'Копіювати посилання',
  open_link: 'Відкрити посилання',
  common_download_img: 'Завантажити IMG',
  please_select_taster: 'Будь ласка, оберіть дегустатора',
  lock_kpi_month_zone:
    "Ваша дія обмежена через замок вибірки KPI, яка активована на вказаний місяць і зону KPI. Якщо у вас є питання, будь ласка, зв' яжіться з власником зони, щоб дізнатися більше про блокування даних KPI.",
  lock_freshness_kpi_month_zone:
    "Ваша дія обмежена через замок вибірки KPI, яка активована на вказаний квартал і зону KPI. Якщо у вас є питання, будь ласка, зв'яжіться з власником зони, щоб дізнатися більше про блокування даних KPI.",
  sit_code_not_exist:
    'Цей код сайту не існує, будь ласка, зверніть увагу на формат коду сайту, наприклад, 001, 002.',
  sit_code_chose:
    'Цей код сайту було обрано, будь ласка, введіть правильний код сайту.',
  common_yes: 'Так',
  common_no: 'Ні',
  common_only_kpi_sample: 'Лише KPI зразок',
  create_ticket: 'Створити тікет',
  sensory_intelligent_platform: 'Інтелектуальна платформа Sensory - PBI',
  external_links: 'Зовнішні посилання',
  evaluation_report: 'Звіт про оцінку',
  download_evaluation_report: 'Завантажити звіт про оцінку',
  preparation: 'Підготовка',
  panel: 'Панель',
  session: 'Сеанс',
  product: 'Продукт',
  attribute: 'Атрибут',
  common_menu_samples: 'Зразки',
  common_menu_rounds: 'Раунди',
  common_menu_groups: 'Групи',
  common_menu_suspension_list: 'Призупинення',
  common_menu_planning_week_sessions: 'Планувальні сесії тижня',
  common_menu_zitec_sessions: 'ZITEC сесії',
  common_menu_brands: 'Бренди',
  common_menu_kpi_brands: 'KPI бренди',
  common_menu_packages: 'Пакети',
  common_menu_styles: 'Стилі',
  common_menu_malt_variety: 'Сорт ячменю',
  common_menu_intensities: 'Інтенсивності',
  common_menu_categories: 'Категорії',
  common_menu_attributes: 'Атрибути',
  common_menu_user_management: 'Керування користувачами',
  common_menu_role_management: 'Керування ролями',
  common_menu_permission_control: 'Керування дозволами',
  system: 'Система',
  select_taste_type: 'Вибрати тип дегустатора',
  select_round: 'Вибрати раунд',
  a_previous_request_is_still_being_processed:
    'Попередній запит ще обробляється. Будь ласка, спробуйте пізніше.',
  select_item: 'Вибрати {{field}}',
  common_new_kpi_brand_button: 'Нова KPI brand',
  kpi_brand_details_title: 'Деталі KPI Brand',
  kpi_brand_details_description:
    'Перегляд повної інформації та статусу процесу затвердження.',
  approval_action: 'Дія затвердження',
  select_approval_action: 'Виберіть дію затвердження',
  reject_reason_title: 'Причина відхилення',
  reject_reason_description: 'Будь ласка, вкажіть причину відхилення.',
  reject_reason_label: 'Причина відхилення',
  reject_reason_placeholder: 'Введіть причину відхилення...',
  reject_reason_placeholder_site:
    "Введіть причину відхилення для цього сайту '{{site}}'...",
  common_confirm: 'Підтвердити',
  common_success: 'Успіх',
  common_save_failed: 'Помилка збереження. Спробуйте знову.',
  comment_cancel_new_title: 'Скасувати створення атрибута смаку?',
  comment_cancel_edit_title: 'Скасувати редагування атрибута смаку?',
  comment_cancel_new_confirm: 'Скасувати створення атрибута смаку',
  comment_cancel_edit_confirm: 'Скасувати редагування атрибута смаку',
  comment_successfully_created: 'Атрибут смаку успішно створено!',
  comment_successfully_created_desc: 'Перегляньте його у списку атрибутів нижче.',
  comment_successfully_updated: 'Атрибут смаку успішно оновлено!',
  comment_successfully_updated_desc: 'Перегляньте його у списку атрибутів нижче.',
  comment_create_failed: 'Не вдалося створити атрибут смаку.',
  comment_update_failed: 'Не вдалося оновити атрибут смаку.',
  comment_failed_desc: 'Спробуйте ще раз за мить.',
  comment_delete_title: 'Видалити атрибут?',
  comment_delete_description:
    'Атрибут {{name}} буде остаточно видалено. Ви впевнені, що хочете продовжити?',
  comment_delete_success: 'Атрибут успішно видалено!',
  comment_delete_success_desc: 'Перегляньте його у списку атрибутів нижче.',
  comment_delete_failed: 'Не вдалося видалити атрибут.',
  comment_delete_failed_desc: 'Спробуйте ще раз за мить.',
  package_list_packages: 'Упаковки',
  package_edit_package: 'Редагувати упаковку',
  package_new_package: 'Нова упаковка',
  packages_page_description:
    'Керуйте всіма типами упаковки та їхніми конфігураціями в одному місці.',
  comment_list_comments: 'Атрибути',
  comments_page_description:
    'Керуйте всіма атрибутами та їхніми конфігураціями в одному місці.',
  comments_new_page_description:
    'Заповніть інформацію про атрибут та завершіть створення.',
  comments_edit_page_description:
    'Відредагуйте інформацію про атрибут та завершіть оновлення.',
  comment_attribute_name: 'Назва атрибута смаку',
  comment_select_category: 'Виберіть категорію смаку',
  comment_edit_comment: 'Редагувати атрибут смаку',
  comment_new_comment: 'Новий атрибут смаку',
  comment_remove_comment: 'Видалити атрибут смаку',
  packages_edit_page_description:
    'Відредагуйте інформацію про упаковку та завершіть оновлення.',
  packages_new_page_description:
    'Заповніть інформацію про упаковку та завершіть створення.',
  package_name: 'Назва упаковки',
  content_already_exists: 'Вміст вже існує.',
  language_english: 'Англійська',
  language_chinese: 'Китайська',
  language_portuguese: 'Португальська',
  language_spanish: 'Іспанська',
  language_dutch: 'Нідерландська',
  language_french: 'Французька',
  language_german: 'Німецька',
  language_russian: 'Російська',
  language_ukrainian: 'Українська',
  language_korean: 'Корейська',
  language_italian: 'Італійська',
  package_volumes: 'Обсяги',
  package_new_volume: 'Новий обсяг',
  package_remove_volume: 'Видалити обсяг',
  package_duplicate: 'Упаковка з такою назвою вже існує',
  package_has_no_english_name:
    "Увага: наявність назви упаковки англійською обов'язкова",
  package_successfully_created: 'Упаковка успішно створена!',
  package_successfully_created_desc: 'Перевірте в списку упаковок нижче.',
  package_successfully_updated: 'Упаковка успішно оновлена!',
  package_successfully_updated_desc: 'Перевірте в списку упаковок нижче.',
  package_remove_package: 'Видалити упаковку',
  cancel_new_package_title: 'Скасувати створення упаковки?',
  cancel_edit_package_title: 'Скасувати редагування упаковки?',
  cancel_new_package_confirm: 'Скасувати створення упаковки',
  cancel_edit_package_confirm: 'Скасувати редагування упаковки',
  unsaved_changes_description:
    'У вас є незбережені зміни. Ви впевнені, що хочете вийти?',
  unsaved_changes_edit_description:
    'У вас є незбережені зміни. Ви впевнені, що хочете вийти?',
  common_error: 'Помилка',
  approval_status_saved_success: 'Статус затвердження успішно збережено!',
  common_target: 'Ціль',
  common_focus_brands: 'Фокусні бренди',
  common_strategic_brands: 'Стратегічні бренди',
  kpi_brands_new_page_description:
    'Інтерфейс створення нового KPI бренду, з функціями для заповнення інформації про KPI бренд, подання та збереження.',
  kpi_brands_edit_page_description:
    'Редагування KPI Brand, з функціями оновлення, надсилання та збереження інформації KPI Brand.',
  kpi_brands_edit_page_description_prefix:
    'Перегляд та налаштування KPI брендів для ',
  kpi_brands_page_description:
    'Інтерфейс управління KPI брендами, з функціями перегляду, подання та перевірки.',
  table_apply: 'Застосувати',
  table_clear: 'Очистити',
  table_search: 'Пошук',
  table_enter_to_filter: 'Введіть для фільтрації...',
  table_select_to_filter: 'Виберіть для фільтрації...',
  table_select_all: 'Вибрати все',
  table_select_all_aria: 'Вибрати всі рядки',
  table_select_row_aria: 'Вибрати рядок',
  table_filter_by: 'Фільтрувати за',
  table_clear_filters: 'Очистити фільтри',
  table_reset_filters: 'Скинути фільтри',
  table_no_results_for_filters: 'За застосованими фільтрами результатів не знайдено.',
  table_items_selected: 'елементів вибрано',
  table_sort: 'Сортувати',
  table_sort_toggle: 'Натисніть, щоб переключити сортування',
  table_no_options: 'Параметри відсутні',
  table_reset: 'Скинути',
  table_all: 'Усі',
  table_no_results: 'Не знайдено результатів для застосованих фільтрів',
  common_approved_at: 'Затверджено {{date}}',
  common_rejected_at: 'Відхилено {{date}}',
  kpi_status_created: 'Створено',
  kpi_status_waiting_for_approval: 'Очікує затвердження',
  kpi_status_approved: 'Затверджено',
  kpi_status_rejected: 'Відхилено',
  kpi_action_approve: 'Схвалити',
  kpi_action_reject: 'Відхилити',
  common_by_user: '{{user}}',
  pagination_aria_label_next_page: 'Перейти на наступну сторінку',
  pagination_aria_label_previous_page: 'Перейти на попередню сторінку',
  pagination_aria_label_first_page: 'Перейти на першу сторінку',
  pagination_aria_label_last_page: 'Перейти на останню сторінку',
  pagination_aria_label_input: 'Введіть бажану сторінку, від 1 до {totalItems}',
  pagination_aria_label_items_per_page:
    'Вибрано {pageSize} елементів на сторінку, натисніть щоб змінити',
  pagination_lines_per_page: 'Рядків на сторінку',
  pagination_total_pages: 'з {totalPages}',
  pagination_total_elements:
    '{firstItem}-{lastItem} з {totalItems} результатів',
  pagination_no_results: 'Результатів не знайдено',
  kpi_brand_successfully_saved: 'KPI brand успішно збережено!',
  kpi_brand_saved_description:
    'Перевірте це в KPI brand нижче. Це лише тимчасове збереження, подання на затвердження ще не завершено.',
  kpi_brand_failed_to_save: 'Не вдалося зберегти KPI brand.',
  kpi_brand_save_failed_description: 'Будь ласка, спробуйте ще раз через мить.',
  kpi_brand_successfully_submitted: 'KPI brand успішно створено!',
  kpi_brand_submitted_description:
    'Перевірте це в KPI brand нижче. Будь ласка, відстежуйте прогресс затвердження на сторінці деталей; цей KPI brand стане доступним лише після затвердження.',
  kpi_brand_failed_to_submit: 'Не вдалося створити KPI brand.',
  kpi_brand_submit_failed_description:
    'Будь ласка, спробуйте ще раз через мить.',
  flavor_id_discussion: 'Обговорення ідентифікації смаків',
  view_and_discussion_for: 'Перегляд та обговорення для',
  common_cup: 'Склянка',
  tasters_joined: 'Приєднані вкусники',
  tasters_all_correct: 'Вкусники з усіма правильними',
  total_accuracy: 'Загальна точність',
  accuracy: 'Точність',
  all_correct: 'Усе правильно',
  otherwise: 'Інші',
  result: 'Результат',
  Key: 'Key',
  nonkey: 'Nonkey',
  common_guest: 'Гість',
  common_filters: 'Фільтри',
  view_correct_answers: 'Переглянути правильні відповіді',
  hide_correct_answers: 'Приховати правильні відповіді',
  change_to_table: 'Перейти до таблиці',
  change_to_card: 'Перейти до карток',
  not_answered: 'Без відповіді',
  upgrade_center: 'Центр оновлень',
  function: 'Функція',
  my_evaluation_report: 'Мій звіт про оцінку',
  actions: 'Дії',
  actions_page_description:
    'Перегляд всіх Дій, створених користувачами під час дегустаційної сесії.',
  action_created_by: 'Створено',
  my_actions: 'Мої Дії',
  action_list_info: 'Дію буде створено після завершення раунду.',
  unsaved_changes_warning:
    'У вас є незбережені зміни. Ви впевнені, що хочете вийти?',
  common_go_back: 'Назад',
  cancel_create_action_title: 'Скасувати створення дії?',
  cancel_edit_action_title: 'Скасувати редагування дії?',
  cancel_create_action_confirm: 'Скасувати створення дії',
  cancel_edit_action_confirm: 'Скасувати редагування дії',
  action_update_failed_desc: 'Повторіть спробу трохи пізніше.',
  action_change_status_successfully: 'Статус змінено!',
  action_change_status_successfully_desc: 'Статус дії змінено на «{{status}}».',
  action_change_status_failed: 'Не вдалося змінити статус',
  action_change_status_failed_desc:
    'Не вдалося змінити статус дії. Повторіть спробу.',
  download_report_success: 'Звіти успішно завантажено!',
  download_report_success_desc: 'Перевірте папку завантажень.',
  download_self_evaluation_report_success:
    'Звіт про самооцінку успішно завантажено!',
  download_report_failed: 'Не вдалося завантажити звіти.',
  download_report_failed_desc: 'Спробуйте ще раз через деякий час.',
  evaluation_report_add_success: 'Звіт успішно додано!',
  evaluation_report_add_success_desc:
    "Перегляньте його у звіті оцінювання 'До завантаження'.",
  evaluation_report_add_failed: 'Не вдалося додати звіт.',
  evaluation_report_add_failed_desc: 'Спробуйте ще раз через деякий час.',
  add_taster: 'Додати дегустатора',
  alcohol_concentration_result: 'Результат концентрації алкоголю',
  absence_save_success: 'Причину відсутності успішно додано!',
  absence_save_success_desc: 'Перегляньте її серед поданих відсутностей.',
  submitted_absence: 'Подані відсутності',
  no_absence_to_show: 'Немає відсутностей для відображення',
  absence_delete_success: 'Причину відсутності успішно видалено!',
  absence_delete_success_desc: 'Перегляньте оновлений список серед поданих відсутностей.',
  absence_delete_confirm_title: 'Видалити відсутність?',
  absence_delete_confirm_description: 'Запис про відсутність [{{start}} - {{finish}}] буде видалено назавжди. Продовжити?',
  absence_delete_confirm_delete: 'Видалити',
  absence_save_failed: 'Не вдалося додати причину відсутності',
  absence_save_failed_desc: 'Спробуйте ще раз через деякий час.',
  absence_duplicate_date_desc:
    'Запис про відсутність для вибраної дати вже існує. Повторне надсилання не дозволено.',
  absence_delete_failed: 'Не вдалося видалити причину відсутності',
  absence_delete_failed_desc: 'Спробуйте ще раз через деякий час.',
  role_management_change_role: 'Змінити роль',
  role_management_reset_success: 'Дозволи успішно скинуто!',
  role_management_reset_success_desc: 'Дозволи цієї ролі скинуто до типової конфігурації. Ви можете переглянути їх у розділі керування дозволами нижче.',
  role_management_reset_failed: 'Не вдалося скинути дозволи.',
  role_management_reset_failed_desc: 'Спробуйте ще раз через деякий час.',
  role_management_switch_role_title: 'Скасувати зміни?',
  role_management_switch_role_description: 'Є незбережені зміни дозволів. Під час зміни ролі їх буде скасовано. Продовжити?',
  role_management_switch_role_confirm: 'Змінити роль',
  role_management_created: 'Користувацьку роль успішно створено!',
  role_management_created_desc: 'Перегляньте її в розділі керування дозволами нижче.',
  role_management_permissions_failed: 'Не вдалося завантажити дозволи.',
  role_management_create_failed: 'Не вдалося створити роль.',
  role_management_create_required: 'Введіть назву ролі та виберіть набір дозволів.',
  role_management_create_failed_desc: 'Повторіть спробу за мить.',
  role_management_create_duplicate: 'Роль із таким ім’ям уже існує!',
  role_management_create_duplicate_desc: 'Введіть інше ім’я ролі та повторіть спробу.',
  role_management_save_success: 'Дозволи ролі успішно оновлено!',
  role_management_save_success_desc: 'Зміни збережено. Переглянути їх можна в розділі керування дозволами нижче.',
  role_management_save_failed: 'Не вдалося зберегти зміни ролі.',
  role_management_save_failed_desc: 'Повторіть спробу за мить.',
  role_management_permission: 'Функція',
  role_management_view: 'Перегляд',
  role_management_edit: 'Редагування',
  role_management_approve: 'Затвердження',
  role_management_search: 'Пошук ролей',
  role_management_current_role_prefix: 'Ваша поточна роль:',
  role_management_create: 'Створити користувацьку роль',
  role_management_save_changes: 'Зберегти зміни',
  common_apply: 'Застосувати',
  role_management_reset_title: 'Скинути дозволи до стандартних?',
  role_management_reset_tooltip: 'Скинути дозволи до конфігурації [{{parentRole}}].',
  role_management_reset_description: 'Дозволи ролі буде скинуто до стандартної конфігурації, а всі ручні зміни видалено. Цю дію не можна скасувати.',
  cancel_create_role_title: 'Скасувати створення користувацької ролі?',
  cancel_create_role_confirm: 'Скасувати створення ролі',
  cancel_create_role_description: 'Ви ввели дані у форму. Після скасування всі незбережені дані буде видалено. Продовжити?',
  role_management_delete_title: 'Видалити користувацьку роль?',
  role_management_default_role: 'стандартна роль',
  role_management_delete_preview_no_users: 'Користувацьку роль «{{role}}» буде назавжди видалено. Продовжити?',
  role_management_create_title: 'Створити користувацьку роль',
  role_management_role_name: 'Назва ролі',
  role_management_permission_set: 'Налаштувати дозволи на основі',
  role_management_role_name_placeholder: 'Введіть назву ролі',
  role_management_permission_set_placeholder: 'Виберіть базову роль',
  role_management_reset_success: 'Дозволи успішно скинуто!',
  role_management_reset_success_desc: 'Дозволи цієї ролі скинуто до стандартної конфігурації. Ви можете переглянути їх у розділі керування дозволами нижче.',
  role_management_reset_failed: 'Не вдалося скинути дозволи.',
  role_management_reset_failed_desc: 'Повторіть спробу за мить.',
};
